import React, {FC, useContext, useEffect} from 'react';
import LoginForm from "./components/LoginForm";
import {BrowserRouter} from "react-router-dom";
import AppRouter from "./components/AppRouter";
import "./css/App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import {Context} from "./index";
import {observer} from "mobx-react-lite";
import { IntlProvider } from 'react-intl';
import { LOCALES } from './i18n/locales'
import { messages } from './i18n/messages'
import Loader from "./components/UI/Loader/Loader";

const App: FC = () => {
    let locale = LOCALES.RUSSIAN;
    const {store} = useContext(Context)
    useEffect( () => {
        if(localStorage.getItem('token')){
            store.checkAuth();
        }
        if(localStorage.getItem('locale')){
            locale = localStorage.getItem('locale') ?? LOCALES.RUSSIAN;
        }
        store.setLocale(locale);

    }, []);

    useEffect(() => {
        let reloading = false;

        const checkFrontendVersion = async () => {
            try {
                const response = await fetch(`/index.html?_=${Date.now()}`, {
                    cache: 'no-store',
                    headers: {'Cache-Control': 'no-cache'},
                });
                if (!response.ok) {
                    return;
                }

                const html = await response.text();
                const nextMainBundle = html.match(/\/static\/js\/main\.[a-z0-9]+\.js/i)?.[0];
                const loadedMainBundle = Array.from(document.scripts)
                    .map(script => script.src ? new URL(script.src, window.location.origin).pathname : '')
                    .find(src => /\/static\/js\/main\.[^/]+\.js$/.test(src));

                if (nextMainBundle && loadedMainBundle && nextMainBundle !== loadedMainBundle && !reloading) {
                    reloading = true;
                    const nextUrl = new URL(window.location.href);
                    nextUrl.searchParams.set('_appv', String(Date.now()));
                    window.location.replace(nextUrl.toString());
                }
            } catch (error) {
                // A temporary network error must not interrupt the current session.
            }
        };

        const checkWhenVisible = () => {
            if (document.visibilityState === 'visible') {
                checkFrontendVersion();
            }
        };

        checkFrontendVersion();
        const interval = window.setInterval(checkFrontendVersion, 30000);
        window.addEventListener('focus', checkFrontendVersion);
        document.addEventListener('visibilitychange', checkWhenVisible);

        return () => {
            window.clearInterval(interval);
            window.removeEventListener('focus', checkFrontendVersion);
            document.removeEventListener('visibilitychange', checkWhenVisible);
        };
    }, []);

    if(store.isLoading){
        return (
            <Loader />
        )
    }

    if(!store.isAuth){
        return (
            <IntlProvider messages={messages[store.locale]} locale={store.locale} defaultLocale={LOCALES.RUSSIAN}>
                <div>
                    <LoginForm  />

                </div>
            </IntlProvider>
        )

    } else {
        return (
            <IntlProvider messages={messages[store.locale]} locale={store.locale} defaultLocale={LOCALES.RUSSIAN}>
                <BrowserRouter>
                    <AppRouter />
                </BrowserRouter>
            </IntlProvider>

        )
    }

}

export default observer(App)
